/// <references types="./custom-typings.d.ts" />
import "core-js";
import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
// import registerServiceWorker from "./registerServiceWorker";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

// See https://github.com/salvoravida/react-adal
import { runWithAdal } from "react-adal";
import { initialize, authContext, getUserRoleAsync } from "./security/security";
import { loadSettings, settings } from "settings";
import { AppInsights } from "applicationinsights-js";

loadSettings().then(async () => {
  initialize(settings);
  // See https://github.com/Microsoft/ApplicationInsights-JS/issues/567
  if (AppInsights.downloadAndSetup !== undefined) {
    AppInsights.downloadAndSetup({ instrumentationKey: settings.telemetryKey });

    AppInsights.trackPageView();
  }

  if (settings.security.enable) {
    runWithAdal(
      authContext,
      async () => {
        await getUserRoleAsync();
        ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);
      },
      !settings.security.enable
    );
  } else {
    await getUserRoleAsync();
    ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);
  }
});
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx